import { render, staticRenderFns } from "./GoodBriefInfo.vue?vue&type=template&id=64d7edd7&scoped=true&"
import script from "./GoodBriefInfo.vue?vue&type=script&lang=js&"
export * from "./GoodBriefInfo.vue?vue&type=script&lang=js&"
import style0 from "./GoodBriefInfo.vue?vue&type=style&index=0&id=64d7edd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d7edd7",
  null
  
)

export default component.exports